import React, { useEffect } from 'react';

const MeniPdf = () => {
  useEffect(() => {
    window.location.replace('/files/SfensionMeni.pdf');
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0a0a0a',
        color: '#c9a227',
        fontFamily: "'Cormorant Garamond', serif",
        letterSpacing: '3px',
        textTransform: 'uppercase',
        fontSize: '14px',
      }}
    >
      Otvaranje menija...
    </div>
  );
};

export default MeniPdf;